import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/baseQuery';
import { METHODS } from 'config';

interface TeamLeaveHeatmapQuery {
  fromDate: string;
  toDate: string;
}

interface UserInfo {
  userId: string;
  firstName: string;
  lastName: string;
  job: string;
}

interface DateLeaveData {
  date: string;
  count: number;
  users: UserInfo[];
}

interface TeamLeaveHeatmapResponse {
  data: DateLeaveData[];
}

const TeamLeaveHeatmapApi = createApi({
  reducerPath: 'team-leave-heatmap-api',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    teamLeaveHeatmap: builder.query<TeamLeaveHeatmapResponse, TeamLeaveHeatmapQuery>({
      query: (body) => ({
        url: '/dashboard/team-leave-heatmap',
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const { useTeamLeaveHeatmapQuery } = TeamLeaveHeatmapApi;
export { TeamLeaveHeatmapApi };
